"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
var SpinnerComponent = (function () {
    function SpinnerComponent() {
        this.size = 'mid';
        this.color = 'primary';
    }
    Object.defineProperty(SpinnerComponent.prototype, "hasBackground", {
        set: function (value) {
            this.attrHasBackground = value ? true : undefined;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SpinnerComponent.prototype, "size", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], SpinnerComponent.prototype, "hasBackground", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SpinnerComponent.prototype, "color", void 0);
    SpinnerComponent = __decorate([
        Component({
            selector: 'fl-spinner',
            template: "\n    <div\n      class=\"Spinner\"\n      role=\"presentation\"\n      [attr.data-size]=\"size\"\n      [attr.data-hasBackground]=\"attrHasBackground\"\n      [attr.data-color]=\"color\">\n    </div>\n  ",
            styleUrls: ['./spinner.component.scss'],
        })
    ], SpinnerComponent);
    return SpinnerComponent;
}());
export { SpinnerComponent };



// WEBPACK FOOTER //
// spinner.component.js